// ----------------------------------------------------------------------------
// Snippet: Header menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_header-menu.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var HAMBURGER_SELECTOR = '.header__link--menu';
var HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_LIST_SELECTOR = '.header-menu__list';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MOBILE_MENU_ITEM_SELECTOR = '.header-menu__list--mobile .header-menu__item--dropdown';
var OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
var DESKTOP_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
var MENU_BUTTON_SELECTOR = '.header-menu__button';
var MOBILE_MENU_BUTTON_SELECTOR = '.header-menu__list--mobile .header-menu__button';
var DESKTOP_MENU_BUTTON_SELECTOR = '.header-menu__list--desktop .header-menu__button';
var MOBILE_MENU_LINK_SELECTOR = '.header-menu__list--mobile .header-menu__link';
var DESKTOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop .header-menu__link';
var DROPDOWN_WRAPPER_SELECTOR = '.header-menu__dropdown-wrapper';

// Classes
var LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
var MENU_BUTTON_CLASS = 'header-menu__button';
var MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
var OPEN_CLASS = 'js--is-open';
var NO_SCROLL_CLASS = 'noscroll';
var closeTimeouts = new Map();
var CLOSE_DELAY = 250;
var INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];

// -------------------------------------
// Helper functions
// -------------------------------------

function initMobileMenu() {
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MOBILE_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR)
  };
  initMenuButtons(menu, 'mobile');
  initMenuLinks(menu, 'mobile');
}
function initDesktopMenu() {
  var menu = {
    $topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(DESKTOP_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR)
  };

  // Hide buttons from tab order on desktop - links handle interaction
  menu.$buttons.forEach(function (button) {
    button.setAttribute('tabindex', '-1');
  });
  initDesktopHover(menu.$topLevelItems);
  initMenuButtons(menu, 'desktop');
  initMenuLinks(menu, 'desktop');
  initDesktopFocusManagement();
}
function initMenuButtons(menu, source) {
  menu.$buttons.forEach(function (button) {
    button.menu = menu;
    button.source = source;
    button.type = 'button';
    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', handleKeydown);
  });
}
function initMenuLinks(menu, source) {
  menu.$links.forEach(function (link) {
    link.menu = menu;
    link.source = source;
    link.type = 'link';
    link.addEventListener('click', handleClick);
    link.addEventListener('keydown', handleKeydown);
    link.addEventListener('focus', handleFocus);
  });
}
function initDesktopHover(topLevelItems) {
  topLevelItems.forEach(function (item) {
    item.addEventListener('mouseenter', handleHover);
    item.addEventListener('mouseleave', handleHover);

    // Add hover handlers to dropdown wrapper to keep it open when hovering over dropdown
    var dropdownWrapper = item.querySelector(DROPDOWN_WRAPPER_SELECTOR);
    if (dropdownWrapper) {
      dropdownWrapper.addEventListener('mouseenter', function () {
        clearCloseTimeout(item);
        var button = getButtonFromItem(item);
        if (button && !item.classList.contains(OPEN_CLASS)) {
          openDropdown(item, button);
        }
      });
      dropdownWrapper.addEventListener('mouseleave', function () {
        scheduleClose(item);
      });
    }
  });
}
function initDesktopFocusManagement() {
  var menuList = document.querySelector('.header-menu__list--desktop');
  if (!menuList) return;

  // Close dropdowns when focus moves outside the menu
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    var openItems = document.querySelectorAll(OPEN_MENU_ITEM_SELECTOR);
    if (openItems.length === 0) return;
    var isWithinMenu = menuList.contains(target) || Array.from(openItems).some(function (item) {
      var dropdownWrapper = item.querySelector(DROPDOWN_WRAPPER_SELECTOR);
      return dropdownWrapper && dropdownWrapper.contains(target);
    });
    if (!isWithinMenu) {
      openItems.forEach(function (item) {
        var button = getButtonFromItem(item);
        if (button) {
          clearCloseTimeout(item);
          closeDropdown(item, button);
        }
      });
    }
  });
}
function handleClick(event) {
  var $this = event.currentTarget;
  event.stopPropagation();
  if ($this.type === 'button') {
    handleMenuButtonInteraction($this, event);
  } else {
    handleMenuLinkInteraction($this, event);
  }
}
function handleKeydown(event) {
  event.stopPropagation();
  handleKeyboardInteraction(event.currentTarget, event);
}
function handleFocus(event) {
  var $this = event.currentTarget;
  var parentItem = $this.parentElement;
  if (parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
    if ($this.menu.$topLevelItems) {
      $this.menu.$topLevelItems.forEach(function (item) {
        var childButton = getButtonFromItem(item);
        if (childButton) {
          closeDropdown(item, childButton);
        }
      });
    }
  }
}
function clearCloseTimeout(item) {
  if (closeTimeouts.has(item)) {
    clearTimeout(closeTimeouts.get(item));
    closeTimeouts.delete(item);
  }
}
function getButtonFromItem(item) {
  return (item === null || item === void 0 ? void 0 : item.querySelector(MENU_BUTTON_SELECTOR)) || null;
}
function scheduleClose(item) {
  clearCloseTimeout(item);
  var button = getButtonFromItem(item);
  if (button) {
    var timeout = setTimeout(function () {
      closeDropdown(item, button);
      closeTimeouts.delete(item);
    }, CLOSE_DELAY);
    closeTimeouts.set(item, timeout);
  }
}
function handleHover(event) {
  var $this = event.currentTarget;
  var button = getButtonFromItem($this);
  if (event.type === 'mouseenter') {
    clearCloseTimeout($this);

    // If switching to a different nav item, close the previous one immediately
    var openItems = document.querySelectorAll(OPEN_MENU_ITEM_SELECTOR);
    openItems.forEach(function (openItem) {
      if (openItem !== $this) {
        var openButton = getButtonFromItem(openItem);
        if (openButton) {
          clearCloseTimeout(openItem);
          closeDropdown(openItem, openButton);
        }
      }
    });

    // Open this dropdown immediately (no delay to prevent flashing)
    if (button) {
      openDropdown($this, button);
    }
  } else {
    var dropdownWrapper = $this.querySelector(DROPDOWN_WRAPPER_SELECTOR);
    var relatedTarget = event.relatedTarget;
    if (dropdownWrapper && relatedTarget && (dropdownWrapper.contains(relatedTarget) || relatedTarget === dropdownWrapper)) {
      return;
    }
    scheduleClose($this);
  }
}
function handleMenuButtonInteraction(button, event) {
  event.preventDefault();
  var parentItem = button.closest(MENU_ITEM_SELECTOR);
  if (parentItem.classList.contains(OPEN_CLASS)) {
    closeDropdown(parentItem, button);
  } else {
    openDropdown(parentItem, button);
  }
}
function handleMenuLinkInteraction(link, event) {
  var href = link.getAttribute('href');
  var isCurrentLink = href === window.location.pathname;
  var isEmptyLink = link.classList.contains(MENU_LINK_EMPTY_CLASS);
  var parentItem = link.closest(MENU_ITEM_SELECTOR);
  var hasDropdown = parentItem && parentItem.querySelector(DROPDOWN_WRAPPER_SELECTOR) !== null;

  // On desktop, if link has a dropdown, Space/Enter should open it
  if (link.source === 'desktop' && hasDropdown && (event.key === ' ' || event.key === 'Enter')) {
    event.preventDefault();
    var button = getButtonFromItem(parentItem);
    if (button) {
      openDropdown(parentItem, button);
      var firstLink = parentItem.querySelector("".concat(DROPDOWN_WRAPPER_SELECTOR, " a[href], ").concat(DROPDOWN_WRAPPER_SELECTOR, " button"));
      if (firstLink) {
        firstLink.focus();
      }
    }
    return;
  }
  var shouldPreventDefault = isEmptyLink || isCurrentLink;
  if (shouldPreventDefault) {
    event.preventDefault();
    if (link.source === 'mobile') {
      closeMenu(link.menu);
    } else {
      var topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
      var _button = getButtonFromItem(topLevelItem);
      if (topLevelItem && _button) {
        closeDropdown(topLevelItem, _button);
      }
    }
  } else if (event.key === ' ') {
    event.preventDefault();
    window.location.assign(href);
  }
}
function handleKeyboardInteraction(element, event) {
  var key = event.key;
  if (!INTERACTION_KEYS.includes(key)) {
    return;
  }
  if (key === ' ' || key === 'Enter') {
    if (element.classList.contains(MENU_BUTTON_CLASS)) {
      handleMenuButtonInteraction(element, event);
    } else {
      handleMenuLinkInteraction(element, event);
    }
  } else if (key === 'Escape') {
    // Find the closest parent dropdown, close it, and focus the associated button
    if (element.source === 'mobile') {
      var closestOpenDropdown;
      if (element.classList.contains(MENU_BUTTON_CLASS)) {
        closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
      } else {
        closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
      }
      if (closestOpenDropdown !== null) {
        var button = getButtonFromItem(closestOpenDropdown);
        if (button) {
          closeDropdown(closestOpenDropdown, button);
          button.focus();
        }
      } else {
        closeMenu(element.menu);
      }
    } else {
      var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
      var _button2 = getButtonFromItem(topLevelItem);
      if (topLevelItem && _button2) {
        closeDropdown(topLevelItem, _button2);
        _button2.focus();
      }
    }
  }
}
function openMenu(menu) {
  if (!menu || !menu.$body || !menu.$header || !menu.$hamburger) return;
  menu.$body.classList.add(NO_SCROLL_CLASS);
  menu.$header.classList.add(OPEN_CLASS);
  menu.$hamburger.classList.add(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'true');
}
function closeMenu(menu) {
  if (!menu || !menu.$body || !menu.$header || !menu.$hamburger) return;
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}
function updateBodyMegamenuClass() {
  if (!window.matchMedia('(min-width: 1024px)').matches) return;
  var openItems = document.querySelectorAll(OPEN_MENU_ITEM_SELECTOR);
  document.body.classList.toggle('megamenu-open', openItems.length > 0);
}
function openDropdown(item, button) {
  item.classList.add(OPEN_CLASS);
  if (button) {
    button.setAttribute('aria-expanded', 'true');
  }
  updateBodyMegamenuClass();
}
function closeDropdown(item, button) {
  if (!item) return;
  clearCloseTimeout(item);
  item.classList.remove(OPEN_CLASS);
  if (button) {
    button.setAttribute('aria-expanded', 'false');
  }
  var childList = item.querySelector(MENU_LIST_SELECTOR);
  if (childList) {
    var childDropdownItems = childList.querySelectorAll(MENU_ITEM_SELECTOR);
    childDropdownItems.forEach(function (childItem) {
      var childButton = getButtonFromItem(childItem);
      if (childButton) {
        childItem.classList.remove(OPEN_CLASS);
        childButton.setAttribute('aria-expanded', 'false');
      }
    });
  }
  updateBodyMegamenuClass();
}
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Helper: Set header height for dropdown positioning
// -------------------------------------

function setHeaderHeight() {
  var header = document.querySelector('.section--header');
  if (!header) return;
  var headerSection = document.querySelector('#shopify-section-header');
  var isSticky = headerSection === null || headerSection === void 0 ? void 0 : headerSection.classList.contains('is-sticky');
  var announcementBarHeight = 0;

  // Only include announcement bar height if NOT sticky
  if (!isSticky) {
    var announcementBarSection = document.querySelector('.section--announcement-bar');
    var announcementBarElement = announcementBarSection === null || announcementBarSection === void 0 ? void 0 : announcementBarSection.querySelector('.announcement-bar');
    if (announcementBarElement && !announcementBarElement.classList.contains('announcement-bar--hidden') && announcementBarElement.offsetHeight > 0) {
      announcementBarHeight = announcementBarSection.offsetHeight;
    }
  }
  var totalHeight = announcementBarHeight + header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', "".concat(totalHeight, "px"));
}

// Export for use in other modules (e.g., sticky header)
if (typeof window !== 'undefined') {
  window.setHeaderHeight = setHeaderHeight;
}

// -------------------------------------
// Helper: Initialize menu based on viewport
// -------------------------------------

var isInitialized = false;
var currentMenuType = null;
function initMenuByViewport() {
  var mobileMedia = window.matchMedia('(max-width: 1023px)');
  var shouldUseMobile = mobileMedia.matches;
  var menuType = shouldUseMobile ? 'mobile' : 'desktop';

  // Only re-initialize if menu type changed
  if (currentMenuType !== menuType) {
    currentMenuType = menuType;
    if (shouldUseMobile) {
      initMobileMenu();
    } else {
      initDesktopMenu();
    }
  }
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  setHeaderHeight();

  // Watch for header height changes (e.g., sticky header state)
  var headerSection = document.querySelector('#shopify-section-header');
  var header = document.querySelector('.section--header');
  if (header && 'ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(function () {
      setHeaderHeight();
    });
    resizeObserver.observe(header);
    if (headerSection) {
      resizeObserver.observe(headerSection);
    }
  }
  initMenuByViewport();
  isInitialized = true;

  // Close dropdowns on scroll (desktop only)
  // window.addEventListener(
  //     'scroll',
  //     function () {
  //         if (window.matchMedia('(min-width: 1024px)').matches) {
  //             const openDropdowns = document.querySelectorAll(
  //                 OPEN_MENU_ITEM_SELECTOR
  //             );
  //             openDropdowns.forEach(function (item) {
  //                 const button = getButtonFromItem(item);
  //                 if (button) {
  //                     clearCloseTimeout(item);
  //                     closeDropdown(item, button);
  //                 }
  //             });
  //         }
  //     },
  //     { passive: true }
  // );
});
window.addEventListener('resize', function () {
  setHeaderHeight();
  if (isInitialized) {
    initMenuByViewport();
  }
});